/**
 * Filtro immagini prodotto per variante — FILYBIJOUX (tema Clarity)
 * --------------------------------------------------------------
 * Come si usa:
 * 1. In Admin > Prodotti > [prodotto] > Media, clicca su ogni immagine
 *    e scrivi nel campo "Testo alternativo" un tag per ogni valore di
 *    opzione a cui l'immagine appartiene, preceduto da #.
 *      Esempio: immagine del Coniglio piccolo -> "#Coniglio #piccolo"
 *      Esempio: immagine del Coniglio valida per tutte le taglie -> "#Coniglio"
 *    Le immagini SENZA nessun tag #... restano SEMPRE visibili
 *    (utile per foto generiche / dettagli / packaging).
 * 2. Nessuna modifica al codice Liquid della galleria è necessaria:
 *    lo script lavora sul DOM già renderizzato dal tema.
 *
 * Comportamento:
 * - Al caricamento della pagina: nessun filtro, si vedono tutte le immagini
 *   (comportamento attuale del tema, invariato).
 * - Dal primo momento in cui l'utente cambia una variante (click/select):
 *   si vedono solo le immagini taggate per quella combinazione + quelle
 *   senza tag.
 * - Compare un pulsante nero ("Vedi tutte le foto") inserito SOTTO la
 *   striscia di miniature, che permette in qualsiasi momento di tornare a
 *   vedere tutte le immagini senza disattivare lo script. Il filtro si
 *   riattiva da solo non appena l'utente sceglie una nuova variante.
 * - Il pulsante viene posizionato UNA SOLA VOLTA (non ad ogni aggiornamento)
 *   per evitare che venga spostato nel DOM proprio mentre lo si clicca.
 *
 * Se il pulsante non si posiziona dove vuoi (il rilevamento automatico
 * è euristico, perché non conosciamo a priori il markup esatto del tema),
 * imposta qui sotto CONFIG.thumbnailsSelector con il selettore CSS del
 * contenitore delle miniature (lo trovi facendo tasto destro > Ispeziona
 * sulla riga di miniature in Chrome).
 */
(function () {
  "use strict";

  var CONFIG = {
    showAllLabel: "Vedi tutte le foto",
    showFilteredLabel: "Mostra solo questa variante",
    // Selettore CSS manuale del contenitore miniature. Lascia null per
    // rilevamento automatico. Esempio: "#thumbnails-slider-template--xyz"
    thumbnailsSelector: null
  };

  var state = {
    productJson: null,
    initialVariantId: null,
    lastVariantId: null,
    filteringActive: false,
    showAllOverride: false,
    hiddenEls: [],
    btn: null,
    btnWrapper: null,
    btnPlaced: false,
    ready: false, // diventa true solo dopo che la pagina si è "assestata"
    hasUserGestured: false // diventa true solo dopo un vero click/change dell'utente
  };

  function getVariantInput() {
    return document.querySelector(
      'form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] select[name="id"]'
    );
  }

  function currentVariantId() {
    var input = getVariantInput();
    if (input && input.value) return String(input.value);
    try {
      var url = new URL(window.location.href);
      var v = url.searchParams.get("variant");
      if (v) return String(v);
    } catch (e) {}
    return null;
  }

  function fetchProductJson() {
    var path = window.location.pathname.replace(/\/$/, "");
    return fetch(path + ".js", { credentials: "same-origin" })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .catch(function () {
        return null;
      });
  }

  function optionValuesForVariant(id) {
    if (!state.productJson || !id) return null;
    var variants = state.productJson.variants || [];
    var v = null;
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === String(id)) {
        v = variants[i];
        break;
      }
    }
    if (!v) return null;
    return (v.options || []).map(function (o) {
      return String(o).trim().toLowerCase();
    });
  }

  function parseTags(alt) {
    if (!alt) return [];
    var matches = alt.match(/#([^\s#]+)/g);
    if (!matches) return [];
    return matches.map(function (m) {
      return m.slice(1).trim().toLowerCase();
    });
  }

  // Tutte le <img> della pagina. Usata per il filtro vero e proprio: si
  // basa solo sull'attributo alt, quindi funziona anche con lazy-loading
  // di terze parti (che cambia il src ma lascia intatto l'alt).
  function allImages() {
    return Array.prototype.slice.call(document.querySelectorAll("img"));
  }

  // Solo le immagini che l'utente ha effettivamente taggato con #...
  // Usata esclusivamente per capire dove si trova la striscia di
  // miniature (posizionamento del pulsante), non per il filtro.
  function taggedImages() {
    return allImages().filter(function (img) {
      return parseTags(img.getAttribute("alt")).length > 0;
    });
  }

  // Risale il DOM finché il contenitore include SOLO questa immagine,
  // così nascondiamo lo "slide"/thumbnail intero e non solo il tag <img>.
  function findHideTarget(img) {
    var el = img;
    var depth = 0;
    while (el.parentElement && depth < 6) {
      var parent = el.parentElement;
      if (parent.querySelectorAll("img").length > 1) break;
      el = parent;
      depth++;
    }
    return el;
  }

  function restoreHidden() {
    state.hiddenEls.forEach(function (el) {
      el.style.removeProperty("display");
      el.removeAttribute("data-variant-filter-hidden");
    });
    state.hiddenEls = [];
  }

  function widthOf(img) {
    var src = img.currentSrc || img.src || "";
    var match = src.match(/[?&]width=(\d+)/);
    if (match) return parseInt(match[1], 10);
    return img.naturalWidth || img.width || 9999;
  }

  // Individua il contenitore più probabile della striscia di miniature:
  // tra i gruppi di immagini taggate che condividono un antenato comune,
  // sceglie quello con la larghezza media minore (le miniature sono
  // sempre servite più piccole rispetto all'immagine principale).
  function findThumbnailsContainer(images) {
    if (CONFIG.thumbnailsSelector) {
      var manual = document.querySelector(CONFIG.thumbnailsSelector);
      if (manual) return manual;
    }
    if (images.length < 2) return null;

    var groups = new Map();
    images.forEach(function (img) {
      var el = img;
      var depth = 0;
      while (el.parentElement && depth < 6) {
        el = el.parentElement;
        depth++;
        if (el.querySelectorAll("img").length >= Math.max(2, Math.ceil(images.length * 0.5))) {
          break;
        }
      }
      if (!groups.has(el)) groups.set(el, []);
      groups.get(el).push(img);
    });

    var best = null;
    groups.forEach(function (imgs, container) {
      if (imgs.length < 2) return;
      var avgWidth =
        imgs.reduce(function (sum, im) {
          return sum + widthOf(im);
        }, 0) / imgs.length;
      if (!best || avgWidth < best.avgWidth) {
        best = { container: container, avgWidth: avgWidth };
      }
    });

    return best ? best.container : null;
  }

  function ensureButton() {
    if (state.btn) return state.btn;

    var wrapper = document.createElement("div");
    wrapper.id = "variant-image-filter-toggle-wrapper";
    wrapper.style.cssText = "text-align:center;margin:12px 0;position:relative;z-index:2147483647;";

    var btn = document.createElement("button");
    btn.type = "button";
    btn.id = "variant-image-filter-toggle";
    btn.style.cssText =
      "display:none;padding:11px 22px;border-radius:999px;border:none;" +
      "background:#000000;color:#ffffff;font-family:Helvetica, Arial, sans-serif;" +
      "font-size:13px;font-weight:600;letter-spacing:.02em;cursor:pointer;" +
      "position:relative;z-index:2147483647;pointer-events:auto;-webkit-appearance:none;appearance:none;";

    btn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      state.showAllOverride = !state.showAllOverride;
      applyFilter();
    });

    wrapper.appendChild(btn);
    state.btn = btn;
    state.btnWrapper = wrapper;
    return btn;
  }

  // Posiziona il pulsante UNA SOLA VOLTA (non va richiamata ad ogni
  // aggiornamento del filtro, altrimenti il nodo verrebbe rimosso e
  // reinserito nel DOM proprio mentre l'utente prova a cliccarlo).
  function placeButtonOnce() {
    if (state.btnPlaced) return;
    ensureButton();
    var container = findThumbnailsContainer(taggedImages());

    if (container && container.parentElement) {
      container.insertAdjacentElement("afterend", state.btnWrapper);
      state.btnPlaced = true;
      return;
    }

    // fallback: pulsante fisso, sempre visibile, se non troviamo le miniature
    state.btnWrapper.style.position = "fixed";
    state.btnWrapper.style.left = "16px";
    state.btnWrapper.style.bottom = "16px";
    state.btnWrapper.style.margin = "0";
    document.body.appendChild(state.btnWrapper);
    state.btnPlaced = true;
  }

  function updateButton() {
    var btn = ensureButton();
    if (!state.filteringActive) {
      btn.style.display = "none";
      return;
    }
    if (state.showAllOverride) {
      btn.textContent = CONFIG.showFilteredLabel;
      btn.style.display = "inline-block";
    } else if (state.hiddenEls.length > 0) {
      btn.textContent = CONFIG.showAllLabel + " (+" + state.hiddenEls.length + ")";
      btn.style.display = "inline-block";
    } else {
      btn.style.display = "none";
    }
  }

  function applyFilter() {
    if (!state.ready) return; // la pagina non si è ancora assestata
    var id = currentVariantId();

    if (!state.filteringActive) {
      // Attiviamo il filtro solo se: (a) c'è stato un vero gesto
      // dell'utente (click/change) E (b) la variante è diversa da quella
      // di partenza. Richiedere entrambe le condizioni evita che il filtro
      // scatti da solo per un aggiornamento asincrono del tema al caricamento
      // (il baseline potrebbe non essere ancora sincronizzato con l'URL).
      if (!state.hasUserGestured || id === state.initialVariantId) {
        updateButton();
        return;
      }
      state.filteringActive = true;
      state.lastVariantId = id;
      placeButtonOnce();
    }

    if (id !== state.lastVariantId) {
      // l'utente ha scelto una variante diversa: si riparte filtrando
      state.lastVariantId = id;
      state.showAllOverride = false;
    }

    restoreHidden();

    if (state.showAllOverride) {
      updateButton();
      return;
    }

    var selected = optionValuesForVariant(id);
    if (!selected) {
      updateButton();
      return;
    }

    allImages().forEach(function (img) {
      var tags = parseTags(img.getAttribute("alt"));
      if (tags.length === 0) return; // immagine generica: sempre visibile

      var matches = tags.every(function (t) {
        return selected.indexOf(t) !== -1;
      });

      if (!matches) {
        var target = findHideTarget(img);
        target.style.display = "none";
        target.setAttribute("data-variant-filter-hidden", "true");
        state.hiddenEls.push(target);
      }
    });

    updateButton();
  }

  function markGestureAndApply() {
    state.hasUserGestured = true;
    applyFilter();
  }

  function init() {
    ensureButton();

    // Usiamo isTrusted per accettare SOLO eventi generati da un'azione
    // reale dell'utente (click/tap veri). Molti temi, incluso Clarity,
    // scatenano eventi "change" sintetici (isTrusted: false) mentre
    // inizializzano gli swatch al caricamento pagina: senza questo
    // controllo venivano scambiati per un vero cambio variante.
    document.addEventListener(
      "change",
      function (e) {
        if (!e.isTrusted) return;
        markGestureAndApply();
      },
      true
    );
    document.addEventListener(
      "click",
      function (e) {
        if (!e.isTrusted) return;
        if (state.btn && (e.target === state.btn || state.btn.contains(e.target))) return;
        setTimeout(markGestureAndApply, 50);
      },
      true
    );

    fetchProductJson().then(function (json) {
      state.productJson = json;
      if (!json) return;

      var input = getVariantInput();
      if (input) {
        var observer = new MutationObserver(function () {
          if (state.ready) applyFilter();
        });
        observer.observe(input, { attributes: true, attributeFilter: ["value"] });
      }

      // Aspettiamo che la pagina sia completamente caricata (immagini,
      // script del tema inclusi) prima di fissare la variante di
      // partenza: alcuni temi sincronizzano la selezione con l'URL in
      // modo asincrono, e leggerla troppo presto falsava il confronto.
      function markReady() {
        if (state.ready) return;
        state.initialVariantId = currentVariantId();
        state.ready = true;
      }

      if (document.readyState === "complete") {
        setTimeout(markReady, 500);
      } else {
        window.addEventListener("load", function () {
          setTimeout(markReady, 500);
        });
      }

      // Rete di sicurezza: alcuni temi aggiornano il valore della variante
      // via JS senza scatenare eventi nativi "change".
      setInterval(applyFilter, 400);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();